import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AmsBillingCodeListItem extends AmsListItemBase {
    id: number = 0;
    amsBillingCode: string = '';
    description: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Billing Code', width: 100, dataIndex: 'amsBillingCode', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Description', width: 200, dataIndex: 'description'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AmsBillingCodeListItem.prototype.amsBillingCode, orderByAscending: true };

    public static formatData(data: AmsBillingCodeListItem[]) {
        return data.map((d: AmsBillingCodeListItem) => ({
          ...d,
        }));
    }

}
